let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("kxSQb")]).then(() => parcelRequire('8su69'));